import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function OpsFinalCTA() {
  return (
    <section id="contact" data-testid="section-final-cta" className="relative bg-[#142645] text-[#F1ECE0] border-t border-white/5 overflow-hidden">
      <img
        src="/ops-photo-hero.png"
        alt=""
        aria-hidden
        className="absolute inset-0 w-full h-full object-cover opacity-12"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#142645]/85 to-[#142645]" />
      <div className="absolute -top-40 -right-40 h-[520px] w-[520px] rounded-full bg-[#D9FF3C]/12 blur-[140px] pointer-events-none" />

      <div className="relative max-w-[1200px] mx-auto px-6 md:px-12 py-24 md:py-32 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="font-editorial text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-[1.05] tracking-tight max-w-4xl mx-auto"
        >
          Ready to understand
          <br />
          <span className="italic">your business better?</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="mt-8 text-base md:text-lg text-[#F1ECE0]/75 max-w-2xl mx-auto leading-relaxed"
        >
          Whether you&apos;re a startup, SME, financial institution, hospital, farm, restaurant,
          government agency, or growing enterprise, OpsIQ is ready to help you unlock the value
          of your business data.
        </motion.p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.97 }} transition={{ type: "spring", stiffness: 300, damping: 22 }}>
            <Link
              to="/book"
              data-testid="final-cta-book"
              className="inline-flex items-center gap-2 px-6 py-4 bg-[#D9FF3C] text-[#142645] text-xs uppercase tracking-[0.22em] font-semibold hover:bg-[#E4FF66] transition-colors"
            >
              Book a consultation <ArrowUpRight size={16} />
            </Link>
          </motion.div>
          <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.97 }} transition={{ type: "spring", stiffness: 300, damping: 22 }}>
            <Link
              to="/contact"
              data-testid="final-cta-demo"
              className="inline-flex items-center gap-2 px-6 py-4 border border-[#F1ECE0]/25 text-[#F1ECE0] text-xs uppercase tracking-[0.22em] font-semibold hover:border-[#F1ECE0] hover:bg-[#F1ECE0]/5 transition-colors"
            >
              Request a demo
            </Link>
          </motion.div>
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-[11px] font-plex-mono uppercase tracking-[0.22em] text-[#F1ECE0]/60">
          <span>info@OpsIQ.live</span>
          <span className="hidden md:inline">·</span>
          <span>www.OpsIQ.live</span>
          <span className="hidden md:inline">·</span>
          <span>Accra · Ghana</span>
        </div>
      </div>
    </section>
  );
}
